import { environment } from '../../environments/environment';
import { AppUrlConstant } from '../constant/app-url';

export class privateApiUrl {
    private static readonly PRIVATE_API_URL = `${environment.apiUrl}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.PRIVATE}${AppUrlConstant.URL_SEPARATOR}`;

    // Api related to the user module
    public static readonly USER_INFO = `${this.PRIVATE_API_URL}user/user_login_info`;
    public static readonly LOGOUT = `${this.PRIVATE_API_URL}user/logout`;

    // Api related to the Dashboard Module
    public static readonly DASHBOARD_CARDS = `${this.PRIVATE_API_URL}dashboard/fetch_dashboard_top_cards`;

    // Below api is used to generate the private token before accessing the websocket
    public static readonly WEB_SOCKET_TOKEN = `${environment.webSocketDomainUrl}${AppUrlConstant.URL_SEPARATOR}token`;

    // Api url for the parameter module
    public static readonly PARAMETER_LIST = `${this.PRIVATE_API_URL}parameters/search_parameters`;
    public static readonly USER_LIST = `${this.PRIVATE_API_URL}user/search_user`;
    public static readonly NOTIFICATION_LIST = `${this.PRIVATE_API_URL}notifications/search_notifications`;
    public static readonly DEVICE_LIST = `${this.PRIVATE_API_URL}device/search_device`;

    // Api Url for the live data module
    public static readonly LIVE_DATA_DEVICE_LIST = `${this.PRIVATE_API_URL}dashboard/fetch_device_tenant_location_info`;
    public static readonly LIVE_DATA_DEVICE_PARAMETER_LIST = `${this.PRIVATE_API_URL}dashboard/fetch_industry_header`;
    public static readonly DEVICE_INTELLIGENCE = `${this.PRIVATE_API_URL}dashboard/fetch_device_intelligence`;
}
